import { i18n } from '@/boot/i18n';
import ErrorHandler from '@/tools/errorHandler';
import * as types from './mutationTypes';
// eslint-disable-next-line import/no-cycle
import IpService from '../../../services/ip';

function validateUniqueIp({ ip, ips }) {
  return !ips.find((item) => item.ip === ip);
}

function validateIp({ ip }) {
  const re = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
  return re.test(ip);
}

const validators = () => ({
  ipValidations: {
    field: 'ip',
    validations: [
      { method: validateUniqueIp, message: i18n.t('general.rules.ip_duplicated') },
      { method: validateIp, message: i18n.t('general.rules.ip') },
    ],
  },
});

export default {
  initState({ commit, dispatch }) {
    commit(types.SET_IPS, []);
    commit(types.SET_REMOVED_IPS, []);
    const validator = validators();
    dispatch('validator/addValidator', validator.ipValidations, { root: true });
  },
  clearState({ commit }) {
    commit(types.CLEAR_IPS);
    commit(types.CLEAR_IP);
    commit(types.CLEAR_REMOVED_IPS);
  },
  async getAll({ rootState, commit }) {
    const response = await IpService.getAll(rootState.organization.organization.uuid);
    if (response.data.data) {
      commit(types.SET_IPS, response.data.data);
    }
  },
  async create({ rootState, state, dispatch }) {
    const ipsSave = state.ips.filter((ip) => ip.uuid === null);

    if (!ipsSave?.length) return;

    const createPromises = [];
    for (let i = 0; i < ipsSave.length; i += 1) {
      const ip = ipsSave[i];
      createPromises.push(IpService.create(
        rootState.organization.organization.uuid,
        { ip: ip.ip },
      ));
    }

    try {
      const responses = await Promise.all(createPromises);
      for (let i = 0; i < responses.length; i += 1) {
        const response = responses[i];

        for (let ipI = 0; ipI < ipsSave.length; ipI += 1) {
          if (ipsSave[ipI].ip === response.data.data.ip) {
            ipsSave[ipI].uuid = response.data.data.uuid;
          }
        }
      }

      dispatch('ui/showToastSuccess', i18n.t('organization.messages.create_ip_success'), { root: true });
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async delete({
    rootState, state, dispatch, commit,
  }) {
    if (!state.removedIps?.length) return;

    const deletePromises = [];
    for (let i = 0; i < state.removedIps.length; i += 1) {
      const ip = state.removedIps[i];
      deletePromises.push(IpService.delete(rootState.organization.organization.uuid, ip.uuid));
    }

    try {
      await Promise.all(deletePromises);
      dispatch('ui/showToastSuccess', i18n.t('organization.messages.create_ip_success'), { root: true });
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });
    }
    commit(types.CLEAR_REMOVED_IPS);
  },
  async resetIps({ dispatch }, uuid) {
    try {
      await IpService.reset(uuid);
      dispatch('ui/showToastSuccess', i18n.t('organization.messages.reset_ips_success'), { root: true });
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  setIp({ commit }, ip) {
    commit(types.SET_IP, ip);
  },
  async addIp({ commit, dispatch, state }) {
    const valid = await dispatch(
      'validator/validate',
      { field: 'ip', value: { ip: state.ip, ips: state.ips } },
      { root: true },
    );
    if (valid) {
      commit(types.ADD_IP);
    }
  },
  removeIp({ commit }, ip) {
    commit(types.REMOVE_IP, ip);
  },
};
